import { ElMessage, ElMessageBox } from "element-plus";
import { ref, reactive } from "vue";
import { queryStashList, deleteStashById } from "@/api/stash";
import { postDownload } from "@/utils";

export default function useStashTable() {
  // 搜索条件ref
  const searchRef = ref(null);

  // 调整组件ref
  const adjustRef = ref(null);

  // 搜索条件
  const searchData = reactive({
    number: null,
    name: null,
    orgId: null,
    address: null,
    headId: null,
    remarks: null,
  });

  // 表格loading
  const tableLoading = ref(false);

  // 表格列配置
  const columns = ref([
    {
      label: "仓库编号",
      prop: "number",
    },
    {
      label: "仓库名称",
      prop: "name",
    },
    {
      label: "所属组织",
      prop: "orgName",
    },
    {
      label: "仓库地址",
      prop: "address",
    },
    {
      label: "备注",
      prop: "remarks",
      width: 150,
    },
    {
      label: "负责人",
      prop: "headIdName",
    },
  ]);

  // 表格数据
  const tableData = ref([]);

  // 分页参数
  const pages = reactive({
    page: 1,
    size: 10,
    total: 0,
  });
  const handleSizeChange = (val) => {
    pages.size = val;
    pages.page = 1;
    getList();
  };
  const handleCurrentChange = (val) => {
    pages.page = val;
    getList();
  };
  // 多选选中的数据的ids
  const multipleSelectionIds = ref([]);

  // 数据选中事件
  const handleSelectionChange = (val) => {
    multipleSelectionIds.value = [];
    val.forEach((item) => {
      multipleSelectionIds.value.push(item.id);
    });
  };

  // 获取列表数据
  const getList = () => {
    tableLoading.value = true;
    queryStashList({ ...searchData, page: pages.page, limit: pages.size })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 搜索条件重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    pages.page = 1;
    getList();
  };

  // 点击新增或编辑或详情
  // config: row, type
  const handleAdjust = (row, type) => {
    adjustRef.value?.handleDialogOpen({ row, type });
  };

  // 点击导出
  const handleExport = () => {
    ElMessageBox.confirm("确定导出仓库数据吗？", "导出", {
      confirmButtonText: "导出",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        postDownload("/warehouse/export", {}, "仓库管理数据.xlsx");
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  // 点击删除
  const handleClickDelete = (id, type) => {
    if (type) {
      if (multipleSelectionIds.value.length == 0) {
        return ElMessage.warning("未选中任何数据");
      }
      handleDelete(multipleSelectionIds.value.join(","));
    } else {
      handleDelete(`${id}`);
    }
  };

  // （批量）删除
  const handleDelete = (ids) => {
    ElMessageBox.confirm("确定删除所选数据吗？", "删除", {
      confirmButtonText: "删除",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        deleteStashById(ids).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };
  return {
    searchRef,
    searchData,
    tableLoading,
    columns,
    tableData,
    pages,
    adjustRef,
    getList,
    handleSizeChange,
    handleCurrentChange,
    handleReset,
    handleAdjust,
    handleExport,
    handleClickDelete,
    handleSelectionChange,
  };
}
